export const IMPORT_PRODUCTS_XLSX_PT_BR = {
	header: {
		title: "Importar produtos",
		bulkEditTitle: "Editar produtos em massa",
	},
	layout: {
		tutorial: "Adicione um ou mais produtos de uma vez importando uma planilha.",
		bulkEditTutorial: "Edite um ou mais produtos de uma vez através da planilha.",
	},
	form: {
		totalProducts: "Total de produtos",
		successfullyImported: "Produtos importados",
		productsWithErrors: "Produtos com erro",
		alert: {
			title: "Produtos com erro",
			message:
				"Identificamos alguns produtos com informações incorretas. Baixe a planilha com os erros, corrija os dados e, em seguida, realize a importação novamente.",
		},
		tooltip: {
			totalProducts: "Sua tabela possuia {{totalProducts}} produtos",
			successfullyImported: "{{totalProducts}} produtos já foram cadastrados com sucesso",
			productsWithErrors: "Baixe a tabela com erros e faça o upload novamente",
		},
		warning: {
			title: "Atenção",
			description:
				"O valor dos produtos é informado em centavos, ex: 123 equivale a R$1,23",
		},
		importProductsActiveByDefault: "Importar produtos com o status ativo",
	},
	sheet: {
		columns: {
			name: "Nome",
			systemProductId: "Produto de Sistema",
			category: "Categoria",
			menuCategory: "Categoria do menu",
			description: "Descrição",
			image: "Imagem (ID)",
			imagePreview: "Imagem (visualização)",
			imageIndex: "Imagem (índice)",
			existingImage: "Imagem original",
			basicStorageUnit: "Unidade de medida",
			price: "Preço",
			priceInCents: "Preço em centavos",
			bars: "Bares (separados por ponto e vírgula)",
			hasAlcohol: "Contém álcool?",
			isHiddenFromApp: "Não exibir produto no aplicativo ZigApp",
			fiscalCode: "SKU",
			fiscalNcm: "Fiscal - NCM",
			fiscalCest: "Fiscal - CEST",
			fiscalProductGroup: "Fiscal - Grupo fiscal",
			fiscalProfile: "Fiscal - Perfil fiscal",
			fiscalIcmsBaseCalculoRetSt:
				"Fiscal - Base de Cálculo do ICMS Retido na operação anterior",
			fiscalIcmsValorSubistituto: "Fiscal - Valor do ICMS Próprio do Substituto",
			fiscalIcmsAliquotaFinal: "Fiscal - Alíquota Suportada pelo Consumidor Final",
			isStockable: "Estocável",
			beerBrand: "Marca da cerveja",
			beerStyle: "Estilo da cerveja",
			beerAbv: "ABV - Teor alcoólico",
		},
		sampleFileName: "exemplo_importacao_produtos",
		errorFileName: "importacao_produtos_com_erros",
		auxiliarSheets: {
			bars: "Bares",
			images: {
				ptBr: "PT-BR",
				esMx: "ES-MX",
				id: "ID",
				url: "URL",
				name: "Imagens",
			},
		},
	},
	upload: {
		warning: {
			title: "Atenção",
			description:
				"Utilize apenas a planilha baixada deste place. Planilhas exportadas de outros places não são aceitas.",
		},
	},
	button: {
		continue: "Continuar Importação",
		validating: "Validando...",
		cancel: "Cancelar",
	},
};

export type ImportProductsXlsxTranslation = typeof IMPORT_PRODUCTS_XLSX_PT_BR;
